import { useReducedMotion } from "motion/react";
import { useEffect, useState } from "react";
import { BlacksmithLogomarkSVG } from "@repo/blacksmith-ui/blacksmith-logomark";
import { BlacksmithWordmarkSVG } from "@repo/blacksmith-ui/blacksmith-wordmark";
import {
  RAIL_TRANSITION_EASING,
  RAIL_WIDTH_TRANSITION_MS,
} from "./sidebar/railConstants";

export const BlacksmithLogoSVG = ({
  oneline = false,
}: {
  oneline?: boolean;
}) =>
  oneline ? (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 1154 96">
      <title>Blacksmith</title>
      <path
        fill="currentColor"
        d="M144 0v96H48c0-26.51-21.49-48-48-48V0h144Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M261.075 13.474h13.479v28.632h-13.479v11.788h13.479v28.632h-13.479V96H192V53.895h13.479v-11.79H192V0h69.075v13.474Zm-53.912 67.368h52.228V55.579h-52.228v25.263Zm0-40.421h52.228V15.158h-52.228v25.263Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M304.879 80.842h53.913V96h-69.076V0h15.163v80.842Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M443.029 13.474h13.479V96h-15.163V55.58h-52.228V96h-15.163V13.474h13.479V0h55.596v13.474ZM389.117 40.42h52.228V15.158h-52.228v25.263Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M540.746 13.474h13.479v15.158h-15.163V15.158h-52.228v65.684h52.228V67.368h15.163v15.158h-13.479V96h-55.598V82.526h-13.477V13.474h13.477V0h55.598v13.474ZM584.55 40.42h38.75V26.948h13.477V0h15.163v28.632h-13.478v13.473h-13.478v11.79h13.478v13.473h13.478V96h-15.163V69.053H623.3V55.579h-38.75V96h-15.163V0h15.163v40.42ZM736.179 13.474h13.478v15.158h-15.163V15.158h-52.227v25.263h53.912v13.474h13.478v28.631h-13.478V96h-55.598V82.526h-13.477V67.368h15.163v13.474h52.227V55.579h-53.913V42.105h-13.477V13.474h13.477V0h55.598v13.474ZM806.938 13.474h11.794V0h28.641v13.474h13.479V96h-15.164V15.158h-25.271V96h-15.163V15.158h-25.272V96h-15.163V13.474h13.479V0h28.64v13.474ZM904.655 13.474h11.793V0h28.641v15.158h-26.956v65.684h26.956V96h-28.641V82.526h-11.793V96h-28.641V80.842h26.957V15.158h-26.957V0h28.641v13.474ZM1002.37 13.474h11.8V0h42.11v15.158h-40.43V96h-15.16V15.158h-40.438V0h42.118v13.474ZM1086.61 40.42h52.23V0H1154v96h-15.16V55.58h-52.23V96h-15.16V0h15.16v40.42Z"
      />
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 408 96" fill="none">
      <title>Blacksmith</title>
      <g fill="currentColor">
        <path d="M214.062 57.732h6.256v7.029h-7.038v-6.248h-24.242v11.715h25.024v6.248h6.256v13.276h-6.256V96h-25.806v-6.248h-6.257v-7.029h7.039v6.248h24.242V77.256h-25.024v-6.248h-6.257V57.732h6.257v-6.248h25.806v6.248ZM246.906 57.732h5.474v-6.248h13.295v6.248h6.255V96h-7.038V58.513h-11.73V96h-7.038V58.513h-11.73V96h-7.038V57.732h6.256v-6.248h13.294v6.248ZM292.263 57.732h5.474v-6.248h13.294v7.029h-12.512V88.97h12.512V96h-13.294v-6.248h-5.474V96h-13.294v-7.029h12.512V58.513h-12.512v-7.03h13.294v6.249ZM337.619 57.732h5.474v-6.248h19.551v7.029h-18.768V96h-7.039V58.513h-18.768v-7.03h19.55v6.249ZM376.719 70.228h24.243V51.484H408V96h-7.038V77.256h-24.243V96h-7.037V51.484h7.037v18.744ZM144 95.937H48l-.016-1.238C47.327 68.796 26.095 48 0 48V.063h144v95.874Z" />
        <path
          fillRule="evenodd"
          d="M214.062 6.248h6.256v13.276h-6.256v5.468h6.256v13.276h-6.256v6.248h-32.063V24.992h6.257v-5.468h-6.257V0h32.063v6.248Zm-25.024 31.24h24.242V25.772h-24.242v11.714Zm0-18.744h24.242V7.029h-24.242v11.715Z"
          clipRule="evenodd"
        />
        <path d="M237.516 37.487h25.024v7.03h-32.062V0h7.038v37.487Z" />
        <path
          fillRule="evenodd"
          d="M304.763 6.248h6.256v38.268h-7.038V25.773h-24.242v18.743h-7.038V6.248h6.256V0h25.806v6.248Zm-25.024 12.496h24.242V7.029h-24.242v11.715Z"
          clipRule="evenodd"
        />
        <path d="M353.241 6.248h6.257v7.029h-7.038V7.029h-24.243v30.458h24.243V31.24h7.038v7.03h-6.257v6.247h-25.806v-6.248h-6.256V6.248h6.256V0h25.806v6.248ZM376.696 18.744h17.986v-6.248h6.256V0h7.038v13.277h-6.256v6.247h-6.256v5.468h6.256v6.247h6.256v13.277h-7.038V32.021h-6.256v-6.248h-17.986v18.743h-7.038V0h7.038v18.744Z" />
      </g>
    </svg>
  );

export const AnimatedBlacksmithLogoOneline = () => {
  const prefersReducedMotion = useReducedMotion();
  const [expanded, setExpanded] = useState(false);
  const showWordmark = prefersReducedMotion === true || expanded;

  useEffect(() => {
    if (prefersReducedMotion) return;
    const frame = requestAnimationFrame(() => setExpanded(true));
    return () => cancelAnimationFrame(frame);
  }, [prefersReducedMotion]);

  return (
    <div className="relative mx-auto h-6 w-48">
      <div
        className="relative h-6 overflow-hidden"
        style={{
          width: showWordmark ? 184 : 24,
          transform: showWordmark ? "translateX(4px)" : "translateX(84px)",
          transition: prefersReducedMotion
            ? "none"
            : `width ${RAIL_WIDTH_TRANSITION_MS}ms ${RAIL_TRANSITION_EASING}, transform ${RAIL_WIDTH_TRANSITION_MS}ms ${RAIL_TRANSITION_EASING}`,
        }}
      >
        <div className="absolute left-0 top-1/2 h-4 w-6 -translate-y-1/2">
          <BlacksmithLogomarkSVG />
        </div>
        <div aria-hidden className="absolute left-8 top-1/2 -translate-y-1/2">
          <BlacksmithWordmarkSVG
            expanded={showWordmark}
            animateReveal={!prefersReducedMotion}
            className="h-[15px] w-[152px]"
          />
        </div>
      </div>
    </div>
  );
};

// Phase-locks every emblem instance to a shared page-wide clock: with
// delay = epoch - now, an animation started at mount sits at
// progress = now - epoch, no matter when it mounted. Loading screens hand the
// emblem across several mounts (auth loader → sidebar skeleton → Suspense
// fallback), and this keeps them all rendering one continuous loop instead of
// restarting the animation on each remount.
//
// The epoch is first contentful paint because that is when the SSR'd
// instance's own CSS animation starts, so client-mounted instances line up
// with it. The server renders "0s", which is the correct phase for the SSR'd
// element itself; the client value is stable across renders, so React never
// patches the SSR'd attribute (suppressHydrationWarning silences the expected
// mismatch).
// Captured once so every instance shares the same epoch even when the FCP
// entry isn't available yet (first mount before paint, or a browser without
// Paint Timing); a per-call fallback would phase-offset later instances.
let pageClockEpoch: number | null = null;

const pageClockDelay = () => {
  if (typeof window === "undefined") {
    return "0s";
  }
  if (pageClockEpoch === null) {
    const fcp = performance
      .getEntriesByType("paint")
      .find((e) => e.name === "first-contentful-paint");
    pageClockEpoch = fcp?.startTime ?? performance.now();
  }
  return `${(pageClockEpoch - performance.now()) / 1000}s`;
};

export const BlacksmithLogomarkAnimationSVG = ({
  showStroke = true,
  className,
}: {
  showStroke?: boolean;
  className?: string;
}) => {
  const [animationDelay] = useState(pageClockDelay);

  return (
    <svg
      viewBox="0 0 144 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ?? "p-6"}
    >
      <title>Blacksmith</title>
      {showStroke && (
        <g className="text-neutral-600 dark:text-primary">
          <path
            d="M144 95.937H48l-.016-1.238C47.327 68.796 26.095 48 0 48V.063h144v95.874Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeDasharray="100,800"
            suppressHydrationWarning
            style={{
              animation: "logomark-stroke-sweep 3s linear infinite",
              animationDelay,
            }}
          />
        </g>
      )}
      <g className="text-neutral-300 dark:text-primary/30">
        <path
          d="M144 95.937H48l-.016-1.238C47.327 68.796 26.095 48 0 48V.063h144v95.874Z"
          fill="currentColor"
          suppressHydrationWarning
          style={{
            animation: "logomark-pulse 2s linear infinite",
            animationDelay,
          }}
        />
      </g>
    </svg>
  );
};
